import {selectSearchObj} from '@modifi/router'
import {path, pickBy, startsWith, compose, mapObjIndexed} from 'ramda'

const searchFilterKeys = [
  'filter.externalId',
  'filter.externalCompanyId',
  'search.contextParameters.value',
]

const keyWindowFromUrl = (
  state: Record<string, any>,
  keyWindow?: Record<string, any>
): Record<string, any> => {
  const searchObj = selectSearchObj(state)

  const orderBy = path<string[]>(['orderBy'], searchObj)
  const orderDirection = path<string[]>(['orderDirection'], searchObj)
  const page = parseInt(path<string>(['page'], searchObj) as string, 10) || undefined
  const itemsPerPage =
    parseInt(path<string>(['itemsPerPage'], searchObj) as string, 10) || undefined
  const filters = compose(
    mapObjIndexed((value: any, key: string) => {
      // extract value before colon from search filters
      if (searchFilterKeys.includes(key) && key !== 'search.contextParameters.value') {
        return value.map((str: string) => str.split(':')[0])
      }
      return value
    }),
    pickBy((val, key) => startsWith('filter', key) || startsWith('search', key))
  )(searchObj)

  return {
    orderBy,
    orderDirection,
    pageSize: itemsPerPage,
    pageIndex: (page as number) - 1,
    ...filters,
    ...keyWindow,
  }
}

export const keyWindowFromUrlForTasks = (
  state: Record<string, any>,
  keyWindow?: Record<string, any>
): Record<string, any> => {
  const updatedKeyWindow = keyWindowFromUrl(state, keyWindow)

  // tasks are sorted by order of STATUS(IN_REVIEW -> TODO -> RESOLVED) & then anything
  // set by the user eg. DUE_DATE. Hence hard coding status filter for BE
  return {
    ...updatedKeyWindow,
    orderBy: updatedKeyWindow.orderBy ? ['status', ...updatedKeyWindow.orderBy] : ['status'],
    orderDirection: updatedKeyWindow.orderDirection
      ? ['ASC', ...updatedKeyWindow.orderDirection]
      : ['ASC'],
  }
}
